// App.js (UPDATED version)
import React, { Suspense, lazy } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { Helmet } from "react-helmet";
import "./App.css";
import NavBar from './components/NavBar';
import Footer from './components/Footer';
import Home from './components/Home';
import PrivacyPolicy from './components/PrivacyPolicy';
import ContentPolicy from './components/ContentPolicy';
// FIXED: Import from correct filename
import TermsCondition from './components/TermsofService'; // Changed from TermsOfService
import Disclaimer from './components/Disclaimer';
import Contact from './components/Contact';
import About from './components/About';

// Import routes configuration - FIXED: use calculatorRoutes
import { calculatorRoutes } from './routes'; // Changed from textToolsRoutes

// Loading spinner component
const LoadingSpinner = () => (
  <div className="loading-spinner">
    <div className="spinner"></div>
    <p>Loading tool...</p>
  </div>
);

// Create lazy-loaded component wrapper
const ToolRoute = ({ componentName, title, description, keywords }) => {
  const ToolComponent = lazy(() => import(`./components/Pages/${componentName}`));
  
  return (
    <>
      <Helmet>
        <title>{title}</title>
        <meta name="description" content={description} />
        <meta name="keywords" content={keywords} />
      </Helmet>
      <Suspense fallback={<LoadingSpinner />}>
        <ToolComponent />
      </Suspense>
    </>
  );
};

// Static route components
const HomeRoute = () => (
  <>
    <Helmet>
      <title>Best Free Online Text Tools - Convert, Edit & Generate | Font-Max</title>
      <meta name="description" content="Use our free online text tools to convert, format, and edit text easily. Perfect for writers, developers, and students!" />
      <meta name="keywords" content="text tools, text converter, case changer, word counter, text editor, text generator, font generator, Font-Max" />
    </Helmet>
    <Home />
  </>
);

const ContactRoute = () => (
  <>
    <Helmet>
      <title>Contact Us - Font-Max</title>
      <meta name="description" content="Get in touch with Font-Max.com for any inquiries, feedback, or support. We are here to assist you!" />
      <meta name="keywords" content="contact, Font-Max, customer support, inquiries, feedback" />
    </Helmet>
    <Contact />
  </>
);

const PrivacyPolicyRoute = () => (
  <>
    <Helmet>
      <title>Privacy Policy - Font-Max</title>
      <meta name="description" content="Read the privacy policy for Font-Max.com, detailing how we collect, use, and protect your personal information while you use our tools." />
      <meta name="keywords" content="privacy policy, Font-Max, personal data protection, terms of service, privacy practices" />
    </Helmet>
    <PrivacyPolicy />
  </>
);

const ContentPolicyRoute = () => (
  <>
    <Helmet>
      <title>Content Policy - Font-Max</title>
      <meta name="description" content="Explore the content policy of Font-Max.com, outlining the guidelines for submitting and using content on our tools platform." />
      <meta name="keywords" content="content policy, Font-Max, user content guidelines, acceptable use, content submission rules" />
    </Helmet>
    <ContentPolicy />
  </>
);

const TermsConditionRoute = () => (
  <>
    <Helmet>
      <title>Terms and Conditions - Font-Max</title>
      <meta name="description" content="Review the terms and conditions for using Font-Max.com, outlining the rules and regulations for using our tools platform." />
      <meta name="keywords" content="terms and conditions, Font-Max, website terms, usage agreement, user rules" />
    </Helmet>
    <TermsCondition />
  </>
);

const DisclaimerRoute = () => (
  <>
    <Helmet>
      <title>Disclaimer - Font-Max</title>
      <meta name="description" content="Read the disclaimer for Font-Max.com outlining the limitations of liability and user responsibilities when using the platform." />
      <meta name="keywords" content="disclaimer, Font-Max, liability, user responsibility, website disclaimer" />
    </Helmet>
    <Disclaimer />
  </>
);

const AboutRoute = () => (
  <>
    <Helmet>
      <title>About Us - Font-Max</title>
      <meta name="description" content="Learn more about Font-Max, our mission, vision, and the services we offer to help you with text-based tools." />
      <meta name="keywords" content="about, Font-Max, company, mission, vision, text tools" />
    </Helmet>
    <About />
  </>
);

// Note: If you need a CookiePolicy component, you'll need to create it or remove this route
// const CookiePolicy = lazy(() => import('./components/CookiePolicy'));

const CookiePolicyRoute = () => {
  const CookiePolicy = lazy(() => import('./components/CookiePolicy'));
  return (
    <>
      <Helmet>
        <title>Cookie Policy - Font-Max</title>
        <meta name="description" content="Read Font-Max's Cookie Policy to understand how we use cookies and similar technologies to enhance your experience on our text-based tools website." />
        <meta name="keywords" content="cookie policy, Font-Max, website cookies, text tools, privacy" />
      </Helmet>
      <Suspense fallback={<LoadingSpinner />}>
        <CookiePolicy />
      </Suspense>
    </>
  );
};

function App() {
  return (
    <>
      <BrowserRouter>
        <NavBar />
        <div className="pages">
          <Suspense fallback={<LoadingSpinner />}>
            <Routes>
              {/* Static Routes */}
              <Route path="/" element={<HomeRoute />} />
              <Route path="/Contact" element={<ContactRoute />} />
              <Route path="/PrivacyPolicy" element={<PrivacyPolicyRoute />} />
              <Route path="/ContentPolicy" element={<ContentPolicyRoute />} />
              <Route path="/TermsCondition" element={<TermsConditionRoute />} />
              <Route path="/Disclaimer" element={<DisclaimerRoute />} />
              <Route path="/About" element={<AboutRoute />} />
              <Route path="/CookiePolicy" element={<CookiePolicyRoute />} />
              
              {/* Dynamic Text Tool Routes - FIXED: use calculatorRoutes */}
              {calculatorRoutes.map((route, index) => (
                <Route
                  key={index}
                  path={route.path}
                  element={
                    <ToolRoute
                      componentName={route.component}
                      title={route.title}
                      description={route.description}
                      keywords={route.keywords}
                    />
                  }
                />
              ))}
            </Routes>
          </Suspense>
        </div>
        <Footer />
      </BrowserRouter>
    </>
  );
}

export default App;